import {Slideshow} from './class/Slideshow'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger);

export default function index(){
  const slides = document.getElementById('indexSlides')
  if(slides){
    const slideshow = new Slideshow(slides)
    document.querySelector('.fv__nav__item--prev').addEventListener('click', () => slideshow.prev())
    document.querySelector('.fv__nav__item--next').addEventListener('click', () => slideshow.next())

    setInterval(()=>{
      slideshow.next()
    },8000)
  }

  /*
  const bgColor = "#f4f5f6"
  const picspace = document.querySelector('.picspace')
  const secondEffect = document.querySelector('.second__efe')
  if(picspace && secondEffect){
    gsap.fromTo('.overback',
      {},
      {
        opacity: 1,
        scrollTrigger: {
          trigger: secondEffect,
          endTrigger: '.third',
          start: "top+=25% top",
          end: "top bottom",
          scrub: 1,
          once: false,
          //markers: true
        }
      }
    )
    gsap.fromTo(picspace,
      {},
      {
        background: bgColor,
        scrollTrigger: {
          trigger: secondEffect,
          endTrigger: '.third',
          start: "top+=25% top",
          end: "top bottom",
          scrub: 1,
          once: false,
          //markers: true
        }
      }
    )
    gsap.fromTo('.picspace figure',
      {},
      {
        width: '90%',
        borderRadius: '1rem',
        scrollTrigger: {
          trigger: picspace,
          start: "top bottom",
          end: "bottom top",
          scrub: 2,
          once: false,
        }
      }
    )
    gsap.fromTo('.picspace figure img',
      {},
      {
        scale: 1.4,
        scrollTrigger: {
          trigger: picspace,
          start: "top bottom",
          end: "bottom top",
          scrub: 2,
          once: false,
        }
      }
    )
  }
  */

}


